// Mock data for OutsourcedHub website

export const services = [
  {
    id: 1,
    number: "01",
    title: "Administrative Support",
    description: "From email management to scheduling and data entry, our VAs handle the busywork so you can focus on growth.",
    features: ["Email Management", "Calendar Scheduling", "Data Entry", "Document Processing"],
    icon: "Briefcase"
  },
  {
    id: 2,
    number: "02",
    title: "Customer Service",
    description: "Deliver exceptional support with dedicated VAs trained to represent your brand with professionalism and care.",
    features: ["Live Chat Support", "Email Support", "Ticket Management", "Customer Onboarding"],
    icon: "Headphones"
  },
  {
    id: 3,
    number: "03",
    title: "Technical Support",
    description: "Tech-savvy assistants ready to troubleshoot, maintain systems, and keep your operations running smoothly.",
    features: ["IT Help Desk", "System Monitoring", "Software Testing", "Technical Documentation"],
    icon: "Code"
  },
  {
    id: 4,
    number: "04",
    title: "Creative Services",
    description: "From content creation to design, our creative VAs bring your vision to life with skill and precision.",
    features: ["Content Writing", "Graphic Design", "Social Media Management", "Video Editing"],
    icon: "Palette"
  },
  {
    id: 5,
    number: "05",
    title: "Lead Generation",
    description: "Fill your pipeline with qualified prospects through strategic outreach and data-driven targeting.",
    features: ["Prospect Research", "Cold Outreach", "CRM Management", "Follow-up Sequences"],
    icon: "Target"
  },
  {
    id: 6,
    number: "06",
    title: "Executive Assistance",
    description: "High-level support for executives who need a trusted partner to manage complex schedules and priorities.",
    features: ["Executive Calendar", "Travel Coordination", "Meeting Preparation", "Confidential Tasks"],
    icon: "Crown"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah L.",
    role: "Creative Director",
    company: "Design Studio Co.",
    content: "Outsource Hub completely transformed how we run our backend tasks. Their VAs are sharp, reliable, and proactive—exactly what every growing business needs.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwYnVzaW5lc3MlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzg0ODk5MDk3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "David M.",
    role: "CEO",
    company: "TechVenture Inc.",
    content: "Thanks to Outsource Hub, we cut admin costs and doubled our productivity. Their team made onboarding seamless and support was top-notch.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1600679472868-eae382e28b34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwYnVzaW5lc3MlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzg0ODk5MDk3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Karen T.",
    role: "Operations Coordinator",
    company: "Global Retail Solutions",
    content: "Our VA from Outsource Hub has been a game-changer. From order management to customer service, everything runs smoother—and we finally have time to scale.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwYnVzaW5lc3MlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzg0ODk5MDk3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Michael R.",
    role: "Founder",
    company: "StartupLab",
    content: "The quality of talent at Outsource Hub is unmatched. They found us a VA who fits our culture perfectly and delivers results consistently.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Part-Time",
    description: "Perfect for growing businesses that need consistent support",
    price: "800",
    period: "month",
    hours: "4 hours/day, 5 days/week",
    features: [
      "20 hours/week dedicated support",
      "1 handpicked VA matched to you",
      "Ongoing performance monitoring",
      "Replacement guarantee",
      "Flexible task management",
      "No binding contracts",
      "Weekly progress check-ins"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Full-Time",
    description: "Ideal for businesses ready to scale with a dedicated team member",
    price: "1500",
    period: "month",
    hours: "8 hours/day, 5 days/week",
    features: [
      "40 hours/week dedicated support",
      "1 fully dedicated VA",
      "Priority onboarding & training",
      "Ongoing performance monitoring",
      "Replacement guarantee",
      "Daily progress reports",
      "No binding contracts",
      "Direct communication channels"
    ],
    popular: true
  }
];

export const team = [
  {
    id: 1,
    name: "Jessica Chen",
    role: "Executive Assistant Specialist",
    bio: "10+ years supporting C-level executives",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    role: "Technical Support Lead",
    bio: "Expert in SaaS platforms and troubleshooting",
    image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "Creative Services Manager",
    bio: "Award-winning designer and content strategist",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Alex Thompson",
    role: "Lead Generation Expert",
    bio: "Generated 10M+ in pipeline for clients",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop"
  }
];

export const portfolio = [
  {
    id: 1,
    client: "TechStartup Inc.",
    project: "Complete Admin Overhaul",
    result: "60% time saved on administrative tasks",
    industry: "Technology",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=600&fit=crop"
  },
  {
    id: 2,
    client: "E-commerce Giant",
    project: "Customer Service Scaling",
    result: "200% increase in customer satisfaction",
    industry: "Retail",
    image: "https://images.unsplash.com/photo-1556742111-a301076d9d18?w=800&h=600&fit=crop"
  },
  {
    id: 3,
    client: "Creative Agency",
    project: "Social Media Management",
    result: "500% growth in social engagement",
    industry: "Marketing",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&h=600&fit=crop"
  },
  {
    id: 4,
    client: "Legal Firm",
    project: "Document Processing System",
    result: "40 hours saved weekly on paperwork",
    industry: "Legal",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&h=600&fit=crop"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What services does Outsource Hub provide?",
    answer: "Outsource Hub offers Virtual Assistants, Executive Assistants, Social Media Managers, Legal Assistants, Lead Generation Specialists, and Cold Callers to meet your business needs."
  },
  {
    id: 2,
    question: "Where is Outsource Hub based?",
    answer: "Outsource Hub is headquartered in the Philippines, offering top-tier talent to clients worldwide."
  },
  {
    id: 3,
    question: "What time zones do your assistants work in?",
    answer: "Our virtual assistants can work according to your business hours, whether you are based in the U.S., Europe, or any other region. We offer flexible scheduling to suit your needs."
  },
  {
    id: 4,
    question: "Do your assistants have their own equipment and backup internet?",
    answer: "Yes, all of our virtual assistants are required to have their own equipment and reliable backup internet to ensure seamless service."
  },
  {
    id: 5,
    question: "Is there a minimum contract period?",
    answer: "No, Outsource Hub does not have binding contracts. You have the flexibility to hire for short-term or long-term engagements as per your business requirements."
  },
  {
    id: 6,
    question: "How quickly can I get started?",
    answer: "Most clients are matched with their ideal VA within 48-72 hours. After a brief consultation, we begin the matching process immediately."
  },
  {
    id: 7,
    question: "What if I'm not satisfied with my VA?",
    answer: "We offer a replacement guarantee. If your VA isn't the right fit, we'll find you a better match at no additional cost."
  },
  {
    id: 8,
    question: "How do you ensure quality?",
    answer: "All VAs undergo rigorous screening, skills testing, and training. We also provide ongoing monitoring and performance check-ins to maintain excellence."
  }
];

export const stats = [
  { label: "Active Clients", value: "500+", suffix: "" },
  { label: "Hours Saved", value: "100K+", suffix: "" },
  { label: "Satisfaction Rate", value: "98", suffix: "%" },
  { label: "Countries Served", value: "25+", suffix: "" }
];

export const manifesto = [
  {
    number: "01",
    title: "Better Screening",
    description: "Instead of overwhelming you with dozens of candidates, we handpick the few who truly fit what you need."
  },
  {
    number: "02",
    title: "Better Matching",
    description: "We tailor every recommendation based on your workflow, goals, and company culture—not a one-size-fits-all approach."
  },
  {
    number: "03",
    title: "Better Support",
    description: "Our job doesn't end when you pick a VA. We provide ongoing monitoring, performance check-ins, and replacement support whenever needed."
  }
];

// Form submission mock
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};

export const submitBookingForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking submitted:", formData);
      resolve({ success: true, message: "Consultation booked! Check your email for confirmation." });
    }, 1000);
  });
};
